import Patch from "@shared/models/patch-updater"

export const PLANBOOK_SET_FLAG = {
  name: "PLANBOOK_SET_FLAG",

  params: {
    planbookId: "string",
    field: "string",
    value: "string",
  },

  patches(payload) {
    let patch = Patch.create("planbook", payload.planbookId).set(
      `attributes.flags.${payload.field}`,
      payload.value
    ).patch

    return [patch]
  },
}

export default PLANBOOK_SET_FLAG
